export const javaObjectNotationToJson = (javaObjectNotation) => {
  try {
    const cleanedNotation = javaObjectNotation.match(/\[(.*)\]/)[1];
    const kv = cleanedNotation.split(',');
    const json = {};
    kv.forEach((kv) => {
      const [key, value] = kv.trim().split('=');
      json[key] = value;
    });
    return json;
  } catch (e) {
    console.error(e);
    return null;
  }
};
